'use strict';

import { view } from '@/functions';

const prefix = '/tickets';
export default [
	{
		path: prefix,
		name: 'tickets',
		meta: {
			title: 'Tickets',
		},
		component: () => view('tickets/index')
	},
]; 